"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SET_GALLERY_OPEN = exports.GALLERIES_RECEIVED = exports.GALLERY_OPEN = void 0;
const Entities_1 = require("../../backend/models/Entities");
const EntityStore_1 = require("./EntityStore");
class GalleryStore extends EntityStore_1.default {
    constructor(dispatcher) {
        super(dispatcher, Entities_1.Gallery);
        this.dispatcher = dispatcher;
    }
    setName(name) {
        for (const entity of this.getEntities().results) {
            const upper = entity.name.toUpperCase();
            if (upper === name.replace(/%20/g, ' ').toUpperCase()) {
                this.handleEntity(entity);
                return;
            }
        }
        this.handleEntity(null);
    }
    saveEntities(payload) {
        this.entities = payload;
    }
}
exports.GALLERY_OPEN = 'GALLERY_OPEN';
exports.GALLERIES_RECEIVED = 'GALLERIES_RECEIVED';
exports.SET_GALLERY_OPEN = 'SET_GALLERY_OPEN';
GalleryStore.storeName = 'GalleryStore';
GalleryStore.handlers = {
    GALLERIES_RECEIVED: 'handleEntities',
    GALLERY_OPEN: 'handleEntity',
    SET_GALLERY_OPEN: 'setName',
};
exports.default = GalleryStore;
